import React from 'react';
import PropTypes from 'prop-types';
import { Footer } from './elements';

var TableFooter = function TableFooter(_ref) {
  var colsDef = _ref.colsDef,
      dataTotal = _ref.dataTotal,
      isScrollable = _ref.isScrollable,
      isHoverable = _ref.isHoverable;
  if (!dataTotal) return null;
  return /*#__PURE__*/React.createElement(Footer, {
    "data-testid": "footer-row",
    isScrollable: isScrollable,
    isHoverable: isHoverable
  }, /*#__PURE__*/React.createElement("tr", null, colsDef.map(function (_ref2, columnIndex) {
    var isRowHeader = _ref2.isRowHeader,
        total = _ref2.total,
        format = _ref2.format,
        align = _ref2.align;
    return isRowHeader ? /*#__PURE__*/React.createElement("th", {
      scope: "row",
      key: "total-header-".concat(columnIndex),
      align: align
    }, format ? format(total(dataTotal)) : total(dataTotal)) : /*#__PURE__*/React.createElement("td", {
      key: "total-".concat(columnIndex),
      align: align
    }, format ? format(total(dataTotal)) : total(dataTotal));
  })));
};

var object = PropTypes.object,
    arrayOf = PropTypes.arrayOf,
    bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    number = PropTypes.number,
    oneOf = PropTypes.oneOf,
    oneOfType = PropTypes.oneOfType,
    shape = PropTypes.shape,
    string = PropTypes.string;
/** Prop types. */

TableFooter.propTypes = {
  colsDef: arrayOf(shape({
    align: oneOf(['left', 'center', 'right']),
    isRowHeader: bool,
    filteredBy: func,
    format: func,
    isSortable: bool,
    title: node.isRequired,
    total: func,
    value: func.isRequired,
    width: oneOfType([string, number])
  })).isRequired,
  dataTotal: object,
  isHoverable: bool,
  isScrollable: bool
};
/** Default props. */

TableFooter.defaultProps = {
  dataTotal: null,
  isHoverable: false,
  isScrollable: false
};
export default React.memo(TableFooter);